const localStorageKey = 'fiton:local:token'
const localStorageUserKey = 'fiton:local:userid'
const localStoragePartnerIdKey = 'fiton:local:partnerid'
const selectedProgramKey = 'fiton:local:selectedProgramKey'

const cacheToken = { token: '', userId: '' }

export function getToken() {
  try {
    return localStorage.getItem(localStorageKey) || cacheToken.token
  } catch (e) {
    return cacheToken.token
  }
}
export function setToken(token) {
  cacheToken.token = token
  return localStorage.setItem(localStorageKey, token)
}
export function getUserId() {
  try {
    return localStorage.getItem(localStorageUserKey) || cacheToken.userId
  } catch (e) {
    return cacheToken.userId
  }
}
export function setUserId(id) {
  cacheToken.userId = id
  return localStorage.setItem(localStorageUserKey, id)
}
export function getPartnerId() {
  try {
    return (
      localStorage.getItem(localStoragePartnerIdKey) || cacheToken.partnerId
    )
  } catch (e) {
    return cacheToken.partnerId
  }
}
export function setPartnerId(id) {
  cacheToken.partnerId = id
  return localStorage.setItem(localStoragePartnerIdKey, id)
}

export function clearUserInfo() {
  setToken('')
  setUserId('')
  setPartnerId('')
}

export function getSelectedProgramId() {
  return localStorage.getItem(selectedProgramKey)
}

export function setSelectedProgramId(value) {
  return localStorage.setItem(selectedProgramKey, value)
}
